/**
 * Centralized configuration for the Lumora application
 * This replaces environment variable management with a single JSON config
 */

import configData from './config.json';

export interface Config {
  supabase: {
    url: string;
    anonKey: string;
  };
  oauth: {
    google: {
      clientId: string;
    };
    apple: {
      clientId: string;
    };
  };
  plaid: {
    clientId: string;
    secret: string;
    environment: string;
    sandboxInstitutionId: string;
  };
  api: {
    baseUrl: string;
  };
  environment: 'development' | 'staging' | 'production';
  isTest: boolean;
}

// Type assertion for the imported JSON
export const config: Config = configData as Config;

// Helper functions for common config access
export const getSupabaseUrl = (): string => config.supabase.url;
export const getSupabaseAnonKey = (): string => config.supabase.anonKey;
export const getGoogleClientId = (): string => config.oauth.google.clientId;
export const getAppleClientId = (): string => config.oauth.apple.clientId;
export const getPlaidClientId = (): string => config.plaid.clientId;
export const getPlaidSecret = (): string => config.plaid.secret;
export const getPlaidEnvironment = (): string => config.plaid.environment;
export const getPlaidSandboxInstitutionId = (): string =>
  config.plaid.sandboxInstitutionId;
export const getApiBaseUrl = (): string => config.api.baseUrl;
export const getEnvironment = (): string => config.environment;
export const isTestEnvironment = (): boolean => config.isTest;
export const isProduction = (): boolean => config.environment === 'production';
export const isDevelopment = (): boolean =>
  config.environment === 'development';

export default config;
